'use client';

import { useTranslation } from 'react-i18next';

import { InputField, InputFieldProps } from '../input-field/input-field';
import { useCreditCardFields } from './utils';

export type CardNameFieldProps = Omit<
  InputFieldProps,
  | 'maskOptions'
  | 'maxLength'
  | 'minLength'
  | 'pattern'
  | 'placeholder'
  | 'prefix'
  | 'type'
  | 'validate'
>;

export const CardNameField: React.FC<CardNameFieldProps> = ({
  help,
  ...fieldProps
}) => {
  const { validator } = useCreditCardFields();
  const { t } = useTranslation();

  return (
    // @ts-expect-error: We'll be getting a false error here due to the dynamic nature of the InputField label and aria attributes */
    <InputField
      fieldClasses="Testing-where"
      autoComplete="cc-name"
      label={t('checkout.form.billingFields.nameOnCardLabel')}
      help={help}
      removeCardNumbers={{
        message: t('checkout.form.billingFields.nameOnCardNumberError'),
      }}
      validate={(value) =>
        validator.cardholderName(value).isValid
          ? true
          : t('checkout.form.billingFields.nameOnCardError')
      }
      {...fieldProps}
    />
  );
};
